import { mediaUrl } from "lib/media";
import { fitClass } from "lib/slider";

/**
 * Responsive slide photo. Slides may carry two uploads:
 *   image        wide / landscape, used on tablets and desktops
 *   mobileImage  portrait or square crop, used under 768px (Tailwind `md`)
 * Without a mobile file the desktop one is used everywhere, so this is a
 * drop-in for the old background-image div. Renders nothing without `image`.
 */
export const SLIDE_MOBILE_QUERY = "(max-width: 767px)";

export default function SlideImage({ slide, className = "", style }) {
  const desktop = mediaUrl(slide?.image);
  const mobile = mediaUrl(slide?.mobileImage);
  if (!desktop && !mobile) return null;
  return (
    <picture>
      {mobile && <source media={SLIDE_MOBILE_QUERY} srcSet={mobile} />}
      <img
        src={desktop || mobile}
        alt=""
        aria-hidden="true"
        draggable="false"
        className={`absolute inset-0 w-full h-full ${fitClass(slide?.fit)} object-center select-none pointer-events-none ${className}`}
        style={style}
      />
    </picture>
  );
}
